import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { getVideogameDetail, } from "../actions"
import Loading from './Loading'
import style from "./videogameDetail.module.css"

function VideogameDetail({ id, handleClink }) {
  //const { id } = useParams()
  const dispatch = useDispatch()
  const videogame = useSelector(state => state.videogame)
  const loading = useSelector(state => state.loading)
  const regExp = /<[^>]*>/g
  const desc = videogame.description&&videogame.description.replace(regExp,'')
  useEffect(() => {
    dispatch(getVideogameDetail(id))
    //console.log(videogame)
  }, [])
  
  return (
    <div className={style.overlay}>
        {loading ? <Loading/> : null}
        
        <div className={style.card}>
            <img src={videogame.image} alt={`Videogame ${videogame.name}`}/>
            <button className={style.close} onClick={handleClink}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                </svg>
            </button>
            <div className={style.cardbody}>
                <div className={style.title}>
                    <h2>{videogame.name}</h2>
                    <p>⭐{videogame.rating}</p>
                </div>
                <p className={style.bold}>Released Date: {videogame.releasedDate}</p>
                <div className={style.genrescontainer}>
                    <div className={style.bold}>Genres🧙‍♂: </div>
                        <div className={style.genres}>{ 
                            videogame.genres && videogame.genres.map((genre,index) => <div key={index}>{genre}</div>)
                        }</div>
                </div>
                <div className={style.platformcontainer}>
                    <div className={style.bold}>Platforms📺:</div>
                    <div className={style.platforms}>{ 
                    videogame.platform && videogame.platform.map((platform,index) => <div key={index}>{platform}</div>)
                    }</div>
                </div>
                <div className={style.bold}> Description:
                    <div className={style.description}>
                        {desc}
                    </div>
                </div>
                
                
            </div>
        </div>
        
    </div>
  )
}

export default VideogameDetail